import { render, staticRenderFns } from "./comvnnonpuma.vue?vue&type=template&id=1da9890b&"
import script from "./comvnnonpuma.vue?vue&type=script&lang=js&"
export * from "./comvnnonpuma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection}, component.options.components || {})
